module.exports = {"511526100":"珙泉镇","511526101":"巡场镇","511526102":"孝儿镇","511526103":"底洞镇","511526104":"上罗镇","511526105":"洛表镇","511526106":"洛亥镇","511526107":"王家镇","511526108":"沐滩镇","511526109":"下罗镇","511526110":"曹营镇","511526200":"恒丰乡","511526203":"仁义乡","511526205":"玉和苗族乡","511526209":"罗渡苗族乡","511526211":"石碑乡","511526212":"观斗苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511526.json
// module id = 2178
// module chunks = 0